/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { TicketMessage } from '../../models/ticket-message';
import { TicketMessageUpdate } from '../../models/ticket-message-update';

export interface ApiTicketItemIdMessageMessageIdPut$Params {
  item_id: number;
  message_id: number;
      body: TicketMessageUpdate
}

export function apiTicketItemIdMessageMessageIdPut(http: HttpClient, rootUrl: string, params: ApiTicketItemIdMessageMessageIdPut$Params, context?: HttpContext): Observable<StrictHttpResponse<TicketMessage>> {
  const rb = new RequestBuilder(rootUrl, apiTicketItemIdMessageMessageIdPut.PATH, 'put');
  if (params) {
    rb.path('item_id', params.item_id, {});
    rb.path('message_id', params.message_id, {});
    rb.body(params.body, 'application/x-www-form-urlencoded');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<TicketMessage>;
    })
  );
}

apiTicketItemIdMessageMessageIdPut.PATH = '/api/ticket/{item_id}/message/{message_id}';
